import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TileFront from './TileFront';
import TileBack from './TileBack';

const LEFT_DETAIL_MAX_LEN = 20;
const RIGHT_DETAIL_MAX_LEN = 12;
const TITLE_MAX_LEN = 18;

const truncate = (str, targetLen) => {
  if (!str || str.length <= targetLen) return str;
  return `${str.substring(0, targetLen - 3)}...`;
};

class AssetTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFront: true,
    };
  }

  flipTile(e) {
    e.preventDefault();
    const newState = this.state;
    newState.isFront = !this.state.isFront;
    this.setState(newState);
  }

  render() {
    if (this.state.isFront) {
      return (
        <TileFront
          title={truncate(this.props.frontTitle, TITLE_MAX_LEN)}
          subTitle={this.props.frontSubtitle}
          flipEnabled={this.props.flipEnabled}
          leftInfo={truncate(this.props.frontLeftInfo, LEFT_DETAIL_MAX_LEN)}
          rightInfo={truncate(this.props.frontRightInfo, RIGHT_DETAIL_MAX_LEN)}
          flipTile={(e) => this.flipTile(e)}
          flipLabel={this.props.flipLabel}
          drilldownEnabled={this.props.frontDrilldownEnabled}
          drilldownFunc={(e) => this.props.frontDrilldownFunc(e)}
        />
      );
    }
    return (
      <TileBack
        contentRenderer={this.props.backContentRenderer}
        leftInfo={truncate(this.props.backLeftInfo, LEFT_DETAIL_MAX_LEN)}
        rightInfo={truncate(this.props.backRightInfo, RIGHT_DETAIL_MAX_LEN)}
        flipTile={(e) => this.flipTile(e)}
        flipLabel="< Back"
        drilldownFunc={(e) => this.props.backDrilldownFunc(e)}
        drilldownLabel={this.props.backDrilldownLabel}
        tileContent={this.props.backTileContent}
      />
    );
  }
}

export default AssetTile;

AssetTile.defaultProps = {
  flipEnabled: false,
  frontTitle: ' ',
  frontSubtitle: ' ',
  frontLeftInfo: ' ',
  frontRightInfo: ' ',
  backLeftInfo: ' ',
  backRightInfo: ' ',
  frontDrilldownEnabled: false,
  frontDrilldownFunc: null,
  backDrilldownFunc: null,
  backDrilldownLabel: null,
  backContentRenderer: null,
  backTileContent: null,
};

AssetTile.propTypes = {
  backContentRenderer: PropTypes.func,
  frontTitle: PropTypes.string,
  frontSubtitle: PropTypes.string,
  flipEnabled: PropTypes.bool,
  frontLeftInfo: PropTypes.string,
  frontRightInfo: PropTypes.string,
  backLeftInfo: PropTypes.string,
  backRightInfo: PropTypes.string,
  frontDrilldownEnabled: PropTypes.bool,
  frontDrilldownFunc: PropTypes.func,
  backDrilldownFunc: PropTypes.func,
  backDrilldownLabel: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  backTileContent: PropTypes.object,
};
